import type { FaireProductEntity } from "../../entity_types/product";

export const p_mk822h2r2s: FaireProductEntity = {
  token: "p_mk822h2r2s",
  type: "product",
  name: "Crystal Carved Gemstone Alpaca - You Choose Stone -",
  brandToken: "b_de8f5way8k",
  brandName: "Rock Paradise",
  imageUrl:
    "https://cdn.faire.com/fastly/c572c1b85d62c7f9d3e80ac5e29e11718a1e3cef87879b682389efb2158c412c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7f5f09540419c61a4a1f958ab8e9474f9e55c8459a5ad043972f03db05350c85.jpeg",
    "https://cdn.faire.com/fastly/6e206cde3960e6a601704fb1305f068d5d4ecb758450274a2035055d5b049216.jpeg",
    "https://cdn.faire.com/fastly/47a11f648d8217a1548177e4d7dec8e063d11d531b2086fa5892ae53f9522b4a.jpeg",
    "https://cdn.faire.com/fastly/0179474516824c3614fa11d4e58625e9742138c5d4c04af2dbed2f9bd47005bc.jpeg",
    "https://cdn.faire.com/fastly/8ea6e141f432fde8bb356641db53e94d021f2692cf3a84b583ed7882e25d7f36.jpeg",
    "https://cdn.faire.com/fastly/e4b0f88b5c39e4152110e861e79474aebb4b126cc234892761cf91ce49bd309a.jpeg",
    "https://cdn.faire.com/fastly/cf0856a26cd0d09f852965540c03d6fd35e89230613292ae63c44cf29fa007e5.jpeg",
    "https://cdn.faire.com/fastly/10cd344c19b2514362da1a5e509e09e886be36d37362f12f7f0f8bd33fe3e3f8.jpeg",
    "https://cdn.faire.com/fastly/13f28b604ceff8a2cf40d5c53a527244d56c7c336a022365eef3e57af76c623c.jpeg",
    "https://cdn.faire.com/fastly/b46a3df7bee3f10dbacc1e17a42fe001d4d3a8d82dc1f2e4588c1f7837379528.jpeg",
  ],
  priceDollars: 16.63,
  description:
    'Crystal\n\nThis listing is for 1 (ONE) Carved Gemstone Alpaca - You Choose Stone - (LWS-FLR)\n\nSTOCK PHOTO. Stones may vary in sizes and characteristics as they are natural.\n\nMeasures Approximate : 2" x 1" x 1.25"\n\nYou Select the Stone! Available in:\n\n\n * Moss Agate - Stone of Balance \n * Ocean Jasper - Stone of inner-peace \nThese carved gemstone alpaca would make a great decoration for anyone\'s shelves or desk! The alpaca could sit anywhere in your room and add a whimsical vibe!\n\n **DISCLAIMER: Some of our listings may contain spiritual properties of stones. We offer these only as inspiration and reference. We do not make any claims that stones can make a change in your life.',
  tags: [],
  msrpDollars: 38.8,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:01.705Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
